<template>
  <v-chart class="chart" :option="option" />
  <div class="legend">Taxa presence, <b>true positive counts</b> at the <i>{{rank}}</i> level.</div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { DataZoomComponent } from 'echarts/components';
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
import { ref, defineComponent } from "vue";

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  GridComponent
]);

export default defineComponent({
  name: "Tp",
  props: ['instance', 'sample', 'rank'],
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },
  created() {
    fetch(`data/${this.instance}.tp.json`)
      .then(res => {
        const json_data=res.json();
        return json_data
        })
      .then(json_data => this.create_plot(json_data, this.$props.rank))
  },
  watch: {
    rank (val) {
      this.create_plot(this.json_data, val)
    }
  },
  data () {
    return {
      option: {
        },
      json_data: {},
      plot_data: [],
      labels: []
    }
  },
  methods: {
    create_plot (json_data, rank) {
        // keep the loaded data
        this.json_data=json_data
        // set the filtered data
        this.filtered_data=this.json_data
        this.plot_data = []
        this.labels = []
        if (typeof json_data.toolname !== 'undefined') {
          for(var i in Object.keys(json_data.toolname)) {
            if (json_data.sample[i] == this.sample){
              if (json_data.rank[i] == rank){
                  this.plot_data.push(json_data.value[i])
                  this.labels.push(json_data.toolname[i])
              }
            }
          }
        }
        this.option = ref({
            yAxis: {
              type: 'category',
              data: this.labels
            },
            xAxis: {
                type: 'value',
            },
            dataZoom: [{
                    type: 'slider',
                    top: '0%',
                    height: 15
                }],
            grid: {
                right: '5%',
                bottom: '0%',
                top: '10%',
                left: '5%',
                containLabel: true
            },
            series: [{
                data: this.plot_data,
                type: 'bar',
                showBackground: true,
                backgroundStyle: {
                    color: 'rgba(180, 180, 180, 0.2)'
                },
                color: 'blue'
            }]
        });
      }
  }
});
</script>

<style scoped>
.chart {
  height: 400px;
}
.legend {
  color: black;
  font-size:0.8em;
  padding-top:0.5em;
  margin-top:0.5em;
  text-align:left;
  border: 0 solid black;
  border-top-width: 1px;
}
</style>
